export default "__VITE_ASSET__DAHEQX3h__"